/* ============================================================
   MACASSAR 2026 — comportamiento personalizado
   - Encabezado compacto al hacer scroll (la búsqueda nunca se va)
   - Botón de limpiar en la barra de búsqueda
   - Agregar rápido al carrito desde los resultados del buscador
   - Selector de cantidad en las tarjetas de producto
   - Barra de compra fija en la ficha de producto (móvil)
   ============================================================ */
(function () {
  'use strict';

  var routes = window.routes || {};
  var cartAddUrl = routes.cart_add_url || '/cart/add';

  /* ---------- utilidades ---------- */

  var toastEl = null;
  var toastTimer = null;

  function toast(message) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'mac-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = message;
    // reflow para reiniciar la transición
    void toastEl.offsetWidth;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 2200);
  }

  function sectionUrl(id) {
    // Conservar el query string: en vista previa lleva preview_theme_id y,
    // si se pierde, el fetch se resuelve contra el tema publicado.
    var url = new URL(window.location.href);
    url.searchParams.set('section_id', id);
    return url.pathname + url.search;
  }

  /* ---------- estado local del carrito ----------

     Antes cada toque en el "+" del buscador disparaba TRES peticiones en
     serie: /cart/add, /cart.js y el render completo de la seccion del
     cajon. Agregar 8 piezas = 24 peticiones y el numero solo subia cuando
     la primera resolvia. Peor: una respuesta de /cart.js que reflejaba
     solo parte de los agregados borraba el mapa completo y el contador
     RETROCEDIA (se vio 2 -> 3 -> 2 -> 4 en el video).

     Ahora el estado local manda mientras haya agregados sin confirmar:
     el numero sube en el mismo toque, los agregados se agrupan en UNA
     peticion y el servidor solo se consulta al final de la rafaga. */

  var cartQtyByVariant = {}; // piezas por variante segun el estado local
  var cartItemCount = 0; // total de piezas (la burbuja del encabezado)

  var addQueue = {}; // variante -> piezas pendientes de enviar
  var addTimer = null; // debounce de la rafaga de toques
  var addInFlight = 0; // peticiones /cart/add sin resolver
  var reconcileTimer = null; // debounce de la reconciliacion con el servidor

  /* Pinta cada boton del buscador segun lo que ya hay en el carrito:
     sin piezas -> "+"; con piezas -> verde con el numero.
     Solo escribe cuando el valor cambia, para no disparar en bucle al
     MutationObserver que vigila el desplegable. */
  function paintAddButtons() {
    var buttons = document.querySelectorAll('.mac-res__add[data-variant-id]');
    Array.prototype.forEach.call(buttons, function (btn) {
      var qty = cartQtyByVariant[btn.getAttribute('data-variant-id')] || 0;
      var label = qty ? String(qty) : '+';
      if (btn.textContent.trim() === label) return;

      btn.textContent = label;

      if (qty) {
        btn.setAttribute('data-state', 'done');
        btn.style.fontSize = qty > 9 ? '1.25rem' : '1.45rem';
        btn.setAttribute('aria-label', qty + ' en el carrito. Tocar para agregar otra pieza');
      } else {
        btn.removeAttribute('data-state');
        btn.style.fontSize = '';
        btn.setAttribute('aria-label', 'Agregar al carrito');
      }
    });
  }

  /* El contador se lee directo de /cart.js. Antes se reconstruia con un
     render de seccion, que fallaba en silencio y dejaba la burbuja
     congelada aunque la pieza si se hubiera agregado. */
  function setCartCount(count) {
    var link = document.querySelector('#cart-icon-bubble');
    if (!link) return;

    var bubble = link.querySelector('.cart-count-bubble');

    if (!count) {
      if (bubble) bubble.remove();
      return;
    }

    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = '<span aria-hidden="true"></span>';
      link.appendChild(bubble);
    }

    var num = bubble.querySelector('span[aria-hidden="true"]');
    if (!num) {
      num = document.createElement('span');
      num.setAttribute('aria-hidden', 'true');
      bubble.insertBefore(num, bubble.firstChild);
    }
    num.textContent = count < 100 ? count : '';
  }

  /* Sube (o baja) el estado local YA, sin esperar a la red. Es lo que
     hace que el numero verde y la burbuja respondan en el mismo toque. */
  function bumpLocal(variantId, delta) {
    var key = String(variantId);
    var next = (cartQtyByVariant[key] || 0) + delta;
    if (next <= 0) delete cartQtyByVariant[key];
    else cartQtyByVariant[key] = next;

    cartItemCount = Math.max(0, cartItemCount + delta);
    setCartCount(cartItemCount);
    paintAddButtons();
  }

  /* Verdad del servidor -> estado local. Solo se aplica cuando no hay
     agregados en vuelo; si no, pisaria el conteo optimista con una foto
     vieja (ese era el salto hacia atras). */
  function applyCart(cart) {
    if (typeof cart.item_count === 'number') {
      cartItemCount = cart.item_count;
      setCartCount(cartItemCount);
    }
    cartQtyByVariant = {};
    (cart.items || []).forEach(function (item) {
      /* SUMAR, no asignar. Los descuentos automaticos "compra X llevate Y"
         (aqui: "50% OFF SEGUNDA PIEZA" y "3X2") hacen que Shopify PARTA la
         linea del carrito: con 3 portapasaportes /cart.js devuelve DOS
         entradas de la misma variante (2 a precio lleno + 1 con el
         descuento), no una de 3.

         Con una asignacion, la segunda entrada pisaba a la primera y el
         numero verde mostraba 1 en vez de 3, mientras la burbuja del
         encabezado (que lee cart.item_count) mostraba el total correcto.
         De ahi que los dos numeros no coincidieran. */
      var key = String(item.variant_id);
      cartQtyByVariant[key] = (cartQtyByVariant[key] || 0) + item.quantity;
    });
    paintAddButtons();
  }

  function hasPendingAdds() {
    return addTimer !== null || addInFlight > 0;
  }

  /* Refresca contador y drawer SIN abrir el drawer: asi se pueden agregar
     varias piezas seguidas sin interrumpir al cliente.

     Con taps rapidos se disparan varios fetch de /cart.js y pueden
     resolver fuera de orden; el token descarta las respuestas viejas
     para que un estado anterior no pise al mas reciente. */
  var cartFetchSeq = 0;

  function refreshCart() {
    var seq = ++cartFetchSeq;
    return fetch(window.routes && window.routes.cart_url ? window.routes.cart_url + '.js' : '/cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        if (!cart || seq !== cartFetchSeq) return null;
        if (!hasPendingAdds()) applyCart(cart);
        return cart;
      })
      .catch(function (e) {
        console.warn('[macassar] no se pudo leer /cart.js', e);
        return null;
      });
  }

  /* Refresca el contenido del cajon del carrito.

     Se reemplaza el interior de #CartDrawer, que es el mismo nodo que usa
     el propio Dawn en CartDrawer.renderContents(). Antes se reemplazaba
     .drawer__inner, y eso dejaba intacta la clase is-empty del elemento
     <cart-drawer>.

     Por que importaba: component-cart-drawer.css define

       cart-drawer.is-empty .drawer__inner { display: grid; grid-template-rows: 1fr }
       cart-drawer.is-empty .drawer__header { display: none }

     Si el cliente abria la tienda con el carrito vacio (por ejemplo en
     ventana privada) y luego agregaba piezas por AJAX, is-empty seguia
     puesta: el cajon se volvia una rejilla de UNA sola fila y encimaba
     encabezado, lista y pie en la misma celda. De ahi el carrito en
     blanco con el subtotal abajo. */
  var drawerFetchSeq = 0;

  function refreshCartDrawer(itemCount) {
    var drawer = document.querySelector('cart-drawer');
    var target = document.getElementById('CartDrawer');
    if (!drawer || !target) return;

    var seq = ++drawerFetchSeq;
    fetch(sectionUrl('cart-drawer'))
      .then(function (r) {
        return r.ok ? r.text() : null;
      })
      .then(function (html) {
        if (!html || seq !== drawerFetchSeq) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('CartDrawer');
        if (!fresh) return;

        target.innerHTML = fresh.innerHTML;

        /* is-empty vive en <cart-drawer>. Se sincroniza con el carrito real. */
        if (typeof itemCount === 'number') {
          drawer.classList.toggle('is-empty', itemCount === 0);
        }
        var inner = target.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');

        /* El overlay se reemplazo, hay que volver a colgarle el cierre. */
        var overlay = target.querySelector('#CartDrawer-Overlay');
        if (overlay && typeof drawer.close === 'function') {
          overlay.addEventListener('click', drawer.close.bind(drawer));
        }
      })
      .catch(function (e) {
        console.warn('[macassar] no se pudo refrescar el cajon del carrito', e);
      });
  }

  /* Se pone en true cuando el cajon acaba de pintarse con el HTML que
     vino en la respuesta del propio /cart/add. Sin esto, la
     reconciliacion posterior pedia OTRO render de la seccion completa
     del cajon para dejarlo igual: un viaje al servidor tirado a la
     basura en cada agregado. */
  var drawerFresh = false;

  function refreshCartUI() {
    return refreshCart().then(function (cart) {
      if (drawerFresh) {
        drawerFresh = false;
        return cart;
      }
      refreshCartDrawer(cart && typeof cart.item_count === 'number' ? cart.item_count : null);
      return cart;
    });
  }

  /* Reconciliacion diferida: una sola lectura de /cart.js y un solo
     render del cajon POR RAFAGA, no por toque. Si aun hay agregados sin
     confirmar, se reprograma en vez de leer un carrito a medias. */
  function scheduleReconcile(delay) {
    clearTimeout(reconcileTimer);
    reconcileTimer = setTimeout(function () {
      reconcileTimer = null;
      if (hasPendingAdds()) {
        scheduleReconcile(250);
        return;
      }
      refreshCartUI();
    }, typeof delay === 'number' ? delay : 450);
  }

  function addToCart(items) {
    return fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript'
      },
      body: JSON.stringify({ items: items })
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) throw new Error((data && data.description) || 'error');
        return data;
      });
    });
  }

  /* Agrupa los toques seguidos. Ocho toques al "+" ya no son ocho POST:
     son uno solo con quantity: 8. Ademas evita el 429 "cart throttled"
     de Shopify cuando llegan varias escrituras al mismo carrito. */
  function flushAdds() {
    if (addTimer) {
      clearTimeout(addTimer);
      addTimer = null;
    }

    var sent = addQueue;
    addQueue = {};

    var items = [];
    Object.keys(sent).forEach(function (id) {
      if (sent[id] > 0) items.push({ id: id, quantity: sent[id] });
    });
    if (!items.length) return;

    addInFlight++;
    addToCart(items)
      .then(function () {
        addInFlight--;
        scheduleReconcile(150);
      })
      .catch(function (e) {
        addInFlight--;
        console.error('[macassar] fallo al agregar', e);
        /* Se revierte lo que se habia pintado de forma optimista. */
        Object.keys(sent).forEach(function (id) {
          bumpLocal(id, -sent[id]);
        });
        toast('No se pudo agregar. Intenta de nuevo.');
        scheduleReconcile(150);
      });
  }

  function queueAdd(variantId, quantity) {
    var key = String(variantId);
    addQueue[key] = (addQueue[key] || 0) + (quantity || 1);
    bumpLocal(key, quantity || 1);

    clearTimeout(addTimer);
    addTimer = setTimeout(flushAdds, 280);
  }

  /* ---------- 1. Encabezado compacto al hacer scroll ---------- */

  var headerSection = document.getElementById('shopify-section-header');

  if (headerSection) {
    var compact = false;
    var onScroll = function () {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      var next = y > 90;
      if (next !== compact) {
        compact = next;
        headerSection.classList.toggle('mac-compact', compact);
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- 2. Barra de búsqueda: botón de limpiar ---------- */

  document.addEventListener('input', function (event) {
    var input = event.target.closest ? event.target.closest('.mac-search__input') : null;
    if (!input) return;
    var form = input.closest('.mac-search__form');
    if (!form) return;
    var clear = form.querySelector('.mac-search__clear');
    if (clear) clear.hidden = input.value.length === 0;
  });

  document.addEventListener('click', function (event) {
    var clear = event.target.closest ? event.target.closest('.mac-search__clear') : null;
    if (!clear) return;
    event.preventDefault();
    var form = clear.closest('.mac-search__form');
    var input = form && form.querySelector('.mac-search__input');
    if (!input) return;
    input.value = '';
    clear.hidden = true;
    input.focus();
    // Avisa al componente de Shopify para que cierre los resultados
    input.dispatchEvent(new Event('input', { bubbles: true }));
    var predictive = clear.closest('predictive-search');
    if (predictive && typeof predictive.close === 'function') predictive.close(true);
  });

  /* ---------- 3. Agregar rápido desde el buscador ---------- */

  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('.mac-res__add') : null;
    if (!btn) return;

    // Los productos con varias variantes usan un <a> al producto:
    // ahí no interceptamos nada, el cliente debe elegir opciones.
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.disabled) return;

    event.preventDefault();
    event.stopPropagation();

    /* El numero sube AQUI, antes de tocar la red, y el boton nunca se
       bloquea: se puede tocar diez veces seguidas sin esperas. La red va
       despues, agrupada. */
    queueAdd(variantId, 1);

    var qty = cartQtyByVariant[String(variantId)] || 1;
    toast(qty > 1 ? qty + ' piezas en el carrito' : btn.getAttribute('data-added-text') || 'Agregado al carrito');
  });

  /* ---------- 4. Selector de cantidad en las tarjetas ---------- */

  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('.mac-qty__btn') : null;
    if (!btn) return;

    event.preventDefault();
    var wrap = btn.closest('.mac-qty');
    var input = wrap && wrap.querySelector('.mac-qty__input');
    if (!input) return;

    var step = btn.getAttribute('data-dir') === 'up' ? 1 : -1;
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var value = parseInt(input.value, 10);
    if (isNaN(value)) value = min;

    value = Math.max(min, value + step);
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));

    var minus = wrap.querySelector('[data-dir="down"]');
    if (minus) minus.disabled = value <= min;
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest ? event.target.closest('.mac-qty__input') : null;
    if (!input) return;
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var value = parseInt(input.value, 10);
    if (isNaN(value) || value < min) input.value = min;
    var wrap = input.closest('.mac-qty');
    var minus = wrap && wrap.querySelector('[data-dir="down"]');
    if (minus) minus.disabled = parseInt(input.value, 10) <= min;
  });

  /* ---------- 4a. Ruta rapida del "agregar rapido" de tarjeta ----------

     Dawn hace esto en product-form.js (linea 30):

       formData.append('sections', this.cart.getSectionsToRender()...)

     O sea que /cart/add no solo agrega: ademas renderiza EN EL SERVIDOR
     dos secciones completas (el cajon del carrito entero con todas sus
     lineas, precios, descuentos y subtotal, mas la burbuja del icono) y
     todo eso viaja en la misma respuesta. Recien despues abre el cajon.
     De ahi los ~2 segundos entre el clic y ver el carrito.

     Aqui se atiende el submit en captura, antes de que Dawn se entere:

     1. La burbuja del carrito sube en el MISMO clic, sin esperar la red.
        Ese es el acuse de recibo, y es suficiente: el boton no lleva
        spinner. Se probo con el de Dawn y quedaba feo, porque el texto
        "Agregar" no se ocultaba (la regla de color de esta hoja le gana
        a .button.loading de base.css) y el circulo se dibujaba encima.
     2. Se pide UNA sola seccion en vez de dos: la burbuja ya la pintamos
        nosotros, asi que 'cart-icon-bubble' sobra. Es un render de
        seccion menos por cada agregado.
     3. El cajon abre HASTA que el producto ya esta dentro.
     4. Si falla, se revierte el conteo y no se abre nada.

     Sobre el punto 3: una version anterior abria el cajon de inmediato
     y tapaba el contenido con un velo. Mal por dos motivos: el velo no
     cubria el estado vacio (se alcanzaba a leer el mensaje de carrito
     vacio justo despues de agregar), y aun funcionando, un carrito
     cargando no es mejor que uno correcto un momento despues. El acuse
     inmediato lo da la burbuja.

     Los productos con varias variantes NO pasan por aqui: esos abren el
     modal de Dawn, donde el cliente todavia tiene que elegir opciones. */
  function quickAddFast(form, event) {
    var idInput = form.querySelector('[name="id"]');
    if (!idInput || !idInput.value) return false;

    var drawer = document.querySelector('cart-drawer');
    var target = document.getElementById('CartDrawer');
    if (!drawer || !target || typeof drawer.open !== 'function') return false;

    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = parseInt(qtyInput ? qtyInput.value : '1', 10);
    if (isNaN(qty) || qty < 1) qty = 1;

    var datos = new FormData(form);
    /* El input de id viene disabled en el Liquid y lo habilita el
       constructor de <product-form>. FormData ignora los deshabilitados,
       asi que se fija a mano y no dependemos de ese orden. */
    datos.set('id', idInput.value);
    datos.append('sections', 'cart-drawer');
    datos.append('sections_url', window.location.pathname);

    event.preventDefault();
    event.stopPropagation();

    var btn = form.querySelector('[type="submit"]');

    /* ---- 1. Acuse inmediato, sin tocar la red ---- */
    bumpLocal(idInput.value, qty);

    if (qtyInput) {
      qtyInput.value = qtyInput.getAttribute('min') || '1';
      var wrapQty = qtyInput.closest('.mac-qty');
      var menos = wrapQty && wrapQty.querySelector('[data-dir="down"]');
      if (menos) menos.disabled = true;
    }

    /* ---- 2. La red ---- */
    fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: datos
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        /* Shopify manda status cuando el agregado fallo (sin existencias,
           limite por pedido, variante inexistente). */
        if (!data || data.status) {
          throw new Error((data && data.description) || 'no se pudo agregar');
        }

        var html = data.sections && data.sections['cart-drawer'];
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('CartDrawer');
          if (fresh) {
            target.innerHTML = fresh.innerHTML;
            /* El overlay se reemplazo: hay que volver a colgarle el cierre.
               Los botones de cerrar traen onclick en linea y sobreviven. */
            var overlay = target.querySelector('#CartDrawer-Overlay');
            if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
            /* El cajon ya quedo al dia con esta misma respuesta: que la
               reconciliacion no vuelva a pedir el render completo. */
            drawerFresh = true;
          }
        }

        /* is-empty vive en <cart-drawer>, fuera de #CartDrawer, asi que
           no se reemplaza sola. Si acabamos de agregar, ya no esta vacio. */
        drawer.classList.remove('is-empty');

        /* Recien AHORA se abre: con el producto ya adentro. */
        drawer.open(btn || undefined);
        scheduleReconcile(150);
      })
      .catch(function (e) {
        console.error('[macassar] fallo el agregar rapido de tarjeta', e);
        bumpLocal(idInput.value, -qty);
        toast('No se pudo agregar. Intenta de nuevo.');
        scheduleReconcile(150);
      });

    return true;
  }

  /* Lo que NO pasa por la ruta rapida (el modal de variantes y el
     formulario de la ficha) lo procesa product-form.js de Dawn, que no
     avisa a este script. Se escucha el submit en captura para
     resincronizar cuando el fetch de Dawn ya termino. */
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form.classList) return;

      /* El modal de variantes se queda con el flujo de Dawn. */
      if (form.closest && form.closest('.quick-add') && !form.closest('quick-add-modal')) {
        if (quickAddFast(form, event)) return;
      }

      if (form.getAttribute('data-type') === 'add-to-cart-form') {
        scheduleReconcile(1400);
      }

      /* Tras un agregar rapido de tarjeta, la cantidad vuelve a 1 para
         que el siguiente clic no repita la cantidad anterior. El reset
         corre despues de que FormData ya capturo el valor (sincrono). */
      if (!form.closest('.quick-add')) return;
      var input = form.querySelector('.mac-qty__input');
      if (!input) return;
      setTimeout(function () {
        input.value = input.getAttribute('min') || '1';
        var wrap = input.closest('.mac-qty');
        var minus = wrap && wrap.querySelector('[data-dir="down"]');
        if (minus) minus.disabled = true;
      }, 1200);
    },
    true
  );

  /* Safari/iOS restaura la pagina desde bfcache al volver atras: el DOM
     revive con contadores viejos aunque el carrito haya cambiado en la
     pagina anterior. Se resincroniza al restaurar. */
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) refreshCart();
  });

  /* ---------- 4b. Cambios de carrito hechos por Dawn ----------

     Dawn cambia cantidades y borra lineas desde cart.js, en
     CartItems.updateQuantity(). El boton de la basura usa esa MISMA
     funcion con cantidad 0, asi que ahi pasa todo. El problema: no
     dispara ningun evento al que suscribirse. Este fork de Dawn es
     anterior a pubsub.js (el tema no tiene ese archivo), asi que no
     existe PUB_SUB_EVENTS.cartUpdate.

     Sin este enganche, vaciar el carrito desde el cajon dejaba los
     numeros verdes del buscador congelados. Y como cada toque SUMA
     sobre el estado local, ese numero viejo envenenaba todo lo que
     venia despues: con el carrito ya en 0 pero el boton todavia en 1,
     tres toques mostraban 4 mientras el carrito real tenia 3.

     En vez de duplicar la logica de Dawn, se observa la unica ruta por
     la que TODO cambio de carrito pasa de verdad: la peticion de red.
     Asi queda cubierto el cajon, la pagina de carrito, y cualquier app
     de terceros, sin depender de la version de Dawn. */
  var fetchOriginal = window.fetch;

  if (typeof fetchOriginal === 'function') {
    window.fetch = function (input) {
      var url = '';
      try {
        url = typeof input === 'string' ? input : (input && input.url) || '';
      } catch (e) {
        url = '';
      }

      var promesa = fetchOriginal.apply(this, arguments);

      /* Solo las ESCRITURAS del carrito. /cart.js (lectura) y los
         render de seccion no entran aqui, para no realimentarse. */
      if (url && /\/cart\/(change|update|add|clear)/.test(url)) {
        try {
          promesa.then(
            function () { scheduleReconcile(250); },
            function () { scheduleReconcile(250); }
          );
        } catch (e) {
          /* nunca romper la peticion original por culpa del enganche */
        }
      }

      return promesa;
    };
  }

  /* Si el cliente toca el carrito en otra pestana y vuelve a esta. */
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) scheduleReconcile(200);
  });

  /* ---------- 5. Barra de compra fija (ficha de producto) ---------- */

  function initStickyBuy() {
    var bar = document.querySelector('.mac-stickybuy');
    if (!bar) return;

    var mainForm = document.querySelector('form[data-type="add-to-cart-form"]');
    var mainButton = mainForm && mainForm.querySelector('[name="add"]');
    if (!mainForm || !mainButton) {
      bar.remove();
      return;
    }

    document.body.classList.add('mac-has-stickybuy');

    var barButton = bar.querySelector('.mac-stickybuy__btn');
    var qtyInput = bar.querySelector('.mac-qty__input');
    var barPrice = bar.querySelector('.mac-stickybuy__price');

    /* El precio del Liquid es el de la primera variante. Cuando el
       cliente cambia de variante, Dawn re-renderiza el bloque de precio
       de la ficha ([id^="price-"]); se copia de ahi para que la barra
       nunca muestre un precio distinto al del producto configurado. */
    var priceSource = document.querySelector('.product__info-container [id^="price-"]')
      || document.querySelector('[id^="price-template"]');

    function syncPrice() {
      if (!barPrice || !priceSource) return;
      var el = priceSource.querySelector('.price-item--sale.price-item--last')
        || priceSource.querySelector('.price__sale .price-item--sale')
        || priceSource.querySelector('.price-item--regular');
      var text = el && el.textContent ? el.textContent.trim() : '';
      if (text && barPrice.textContent.trim() !== text) barPrice.textContent = text;
    }

    if (priceSource && window.MutationObserver) {
      new MutationObserver(syncPrice).observe(priceSource, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
    syncPrice();

    /* Mostrar la barra solo cuando el botón real ya no se ve */
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { rootMargin: '0px 0px -20% 0px' }
    );
    observer.observe(mainButton);

    function syncState() {
      var disabled = mainButton.hasAttribute('disabled');
      barButton.disabled = disabled;
      barButton.textContent = disabled
        ? barButton.getAttribute('data-soldout-text') || 'Agotado'
        : barButton.getAttribute('data-add-text') || 'Agregar al carrito';
    }

    new MutationObserver(syncState).observe(mainButton, {
      attributes: true,
      attributeFilter: ['disabled']
    });
    syncState();

    barButton.addEventListener('click', function () {
      var idInput = mainForm.querySelector('[name="id"]');
      if (!idInput || !idInput.value) return;

      var qty = parseInt(qtyInput ? qtyInput.value : '1', 10);
      if (isNaN(qty) || qty < 1) qty = 1;

      /* Mismo criterio que el buscador: se pinta primero, se envia
         despues. El boton no se bloquea. */
      queueAdd(idInput.value, qty);
      flushAdds();
      toast(qty + (qty > 1 ? ' piezas agregadas' : ' pieza agregada'));
      if (qtyInput) qtyInput.value = 1;
    });
  }

  /* ---------- 6. Sincronizacion del estado del buscador ---------- */

  function initSearchState() {
    /* Dawn reemplaza el HTML de los resultados en cada busqueda, asi que
       hay que repintar el estado cada vez que cambia el desplegable. */
    var results = document.querySelector('[data-predictive-search]');
    if (results && window.MutationObserver) {
      new MutationObserver(paintAddButtons).observe(results, {
        childList: true,
        subtree: true
      });
    }
    /* Carga inicial: si el cliente ya traia piezas, los botones lo reflejan. */
    refreshCart();
  }

  /* La burbuja ya viene pintada por Liquid. Se lee para que el primer
     toque pueda sumar sobre el total real sin esperar a /cart.js. */
  function seedCartCount() {
    var num = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
    var parsed = num ? parseInt((num.textContent || '').trim(), 10) : 0;
    cartItemCount = isNaN(parsed) ? 0 : parsed;
  }

  /* Si el cliente abre el carrito en medio de una rafaga, se manda lo
     pendiente de inmediato para que el cajon no muestre menos piezas de
     las que ya toco. */
  function initCartIconFlush() {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    icon.addEventListener(
      'click',
      function () {
        if (!hasPendingAdds() && !reconcileTimer) return;
        flushAdds();
        scheduleReconcile(0);
      },
      true
    );
  }

  function init() {
    seedCartCount();
    initStickyBuy();
    initSearchState();
    initCartIconFlush();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();